import { createSelector } from "reselect";
import get from "lodash/get";
import titleCase from "title-case";

const getSchedulers = state => state.firestore.ordered.schedulers;
const getCustomers = state => state.firestore.data.customers;
const getRegions = state => state.firestore.data.regions;
const getEquipments = state => state.firestore.data.equipments;
const getAgreements = state => state.firestore.data.agreements;

const getScheduler = (state, props) =>
  state.firestore.data.schedulers[props.match.params.id];

const getValue = (collection, docId) => {
  return get(get(collection, docId), "name");
};

export const getSchedulerList = createSelector(
  [getSchedulers, getCustomers, getRegions, getEquipments, getAgreements],
  (schedulers, customers, regions, equipments, agreements) => {
    console.log('tag1',schedulers)
    return (
      schedulers &&
      schedulers.map(scheduler => {
        const customerName = getValue(customers, scheduler.customerId);
        const regionName = getValue(regions, scheduler.regionId);
        const equipmentName = getValue(equipments, scheduler.equipmentId);
        const agreementType = getValue(agreements, scheduler.agreementId);

        return Object.assign({}, scheduler, {
          customerName: customerName,
          regionName: regionName,
          equipmentName: equipmentName,
          agreementType: agreementType,
          status: titleCase(scheduler.status),
        });
      })
    );
  }
);

export const getSchedulerDetails = createSelector(
  [getScheduler, getCustomers, getRegions, getEquipments, getAgreements],
  (scheduler, customers, regions, equipments, agreements) => {
    const { customerId, regionId, equipmentId, agreementId } = scheduler;

    const customerName = getValue(customers, customerId);
    const regionName = getValue(regions, regionId);
    const equipmentName = getValue(equipments, equipmentId);
    const agreementType = getValue(agreements, agreementId);

    return Object.assign({}, scheduler, {
      customerName: customerName,
      regionName: regionName,
      equipmentName: equipmentName,
      agreementType: agreementType,
    });
  }
);

// function isAllItems(value) {
//   return value === "*";
// }

export function schedulerstatus(scheduler) {
  let status = "pending";

  const messages = get(scheduler, "messageSid");

  const checkStatus = status => obj => obj.status === status;

  switch (true) {
    case messages.some(checkStatus("queued")):
      status = "queued";
      break;
    case messages.some(checkStatus("failed")):
      status = "failed";
      break;
    case messages.some(checkStatus("sent")):
      status = "sent";
      break;
    case messages.some(checkStatus("delivered")):
      status = "delivered";
      break;
    case messages.some(checkStatus("undelivered")):
      status = "undelivered";
      break;
    default:
      throw new Error("Unknown status");
  }

  return Object.assign({}, scheduler, {
    status: status,
  });
}
